import { BaseRouteService } from 'core/services';

class PatientNumberRouteService extends BaseRouteService {
    constructor() {
        super('patient-numbers');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,facilityId}', filter);
    }
}

export default PatientNumberRouteService;